import { render, staticRenderFns } from "./FreeNotification.vue?vue&type=template&id=65b67e54&"
import script from "./FreeNotification.vue?vue&type=script&lang=js&"
export * from "./FreeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports